export default "__VITE_ASSET__H5DPs5W5__"